import "./PavilionNudge.scss";
import { useState } from "react";

const NUDGE_IMG = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/pavilion_nudge_final.png";
const NUDGE_LINK = "https://pavilion.hitwicket.com/login";

/**
 * Small sticky "Explore Hitwicket Pavilion" nudge pinned to the bottom-right corner.
 * Floats gently, glows, and can be dismissed until the next reload.
 */
function PavilionNudge() {
    return (
        <div className="PavilionNudge">
            <a href={NUDGE_LINK} target="_blank" rel="noopener noreferrer" className="PavilionNudge-link" aria-label="Explore Pavilion">
                <img src={NUDGE_IMG} alt="" />
            </a>
        </div>
    );
}

export default PavilionNudge;
    